export default __webpack_public_path__ + "static/media/brand.ffc44156.jpg";